<template>
  <div>
    <ComunDialogComp v-model="active" :titleWindow="titleWindow" Deletedialog @close-modal="cancelar()" :loading="loading" 
      @cancel-item="cancelar()" @delete-item="aceptar()">
      <template v-slot:body>
        <v-container class="m-auto">

          {{ title ? title : "Escribe el titulo" }}
        </v-container>
      </template>
    </ComunDialogComp>
  </div>
</template>

<script>
import ComunDialogComp from "@/components/ComponentsEst/ComunDialogComp.vue";

export default {
  components: {
    ComunDialogComp,
  },
  props: ["title", "active", "titleWindow", "loading"],
  methods: {
    cancelar() {
      this.$emit("cancelar");
    },
    aceptar() {
      this.$emit("aceptar");
    },
  },
};
</script>
